import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = localStorage.getItem('comunicar_carrito');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  const [ultimoAgregado, setUltimoAgregado] = useState(null);

  /* Persistir en localStorage */
  useEffect(() => {
    try {
      localStorage.setItem('comunicar_carrito', JSON.stringify(items));
    } catch {}
  }, [items]);

  /* Agregar item — evita duplicados */
  const agregarItem = useCallback((item) => {
    setItems(prev => {
      const existe = prev.find(i => i.id === item.id);
      if (existe) return prev;
      return [...prev, { ...item, cantidad: 1 }];
    });
    setUltimoAgregado(item);
  }, []);

  /* Quitar item por id */
  const quitarItem = useCallback((id) => {
    setItems(prev => prev.filter(i => i.id !== id));
  }, []);

  /* Vaciar carrito */
  const vaciarCarrito = useCallback(() => {
    setItems([]);
  }, []);

  /* Limpiar ultimo agregado (para cerrar el toast) */
  const limpiarUltimoAgregado = useCallback(() => {
    setUltimoAgregado(null);
  }, []);

  /* Verificar si un producto ya está en el carrito */
  const estaEnCarrito = useCallback((id) => {
    return items.some(i => i.id === id);
  }, [items]);

  /* Totales */
  const totalItems = items.length;
  const totalPrecio = items.reduce((acc, i) => acc + (i.precio * (i.cantidad || 1)), 0);

  return (
    <CartContext.Provider value={{
      items,
      agregarItem,
      quitarItem,
      vaciarCarrito,
      estaEnCarrito,
      limpiarUltimoAgregado,
      ultimoAgregado,
      totalItems,
      totalPrecio,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart debe usarse dentro de CartProvider');
  return ctx;
}